import { faAngleDown, faAngleLeft, faAngleRight, faAngleUp } from '@fortawesome/pro-light-svg-icons'

export const DIRECTION_ICONS = {
  up: { expanded: faAngleDown, collapsed: faAngleUp },
  down: { expanded: faAngleUp, collapsed: faAngleDown },
  left: { expanded: faAngleLeft, collapsed: faAngleRight },
  right: { expanded: faAngleRight, collapsed: faAngleLeft },
} as const
